import { createElementBlock as t, openBlock as l, normalizeClass as d, createCommentVNode as o, renderSlot as a, toDisplayString as i } from "vue";
import '../../../../assets/ds-atom-form-field.css';const f = ["for"], s = {
  key: 1,
  class: "mp-form-field__footer"
}, n = {
  key: 0,
  class: "mp-form-field__error u-tiny-text"
}, c = {
  __name: "ds-atom-form-field",
  props: {
    label: {
      type: String,
      default: ""
    },
    valid: {
      type: Boolean,
      default: !0
    },
    error: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    return (r, m) => (l(), t("div", {
      class: d(["mp-form-field", {
        "mp-form-field--error": e.valid === !1
      }])
    }, [
      e.label ? (l(), t("label", {
        key: 0,
        class: "mp-form-field__label u-tiny-text u-bold",
        for: e.id
      }, i(e.label), 9, f)) : o("", !0),
      a(r.$slots, "default"),
      e.error || r.$slots.info ? (l(), t("div", s, [
        e.valid === !1 ? (l(), t("div", n, i(e.error), 1)) : o("", !0),
        a(r.$slots, "info")
      ])) : o("", !0)
    ], 2));
  }
};
export {
  c as default
};
